module.exports = __webpack_public_path__ + "static/an-educator-first-af5f408718c4eb44ddecb8e31832b76d.jpg";